import { createIconComponent } from '../../factory/create-icon-component';
export const ProductionIcon = createIconComponent(
  'ProductionIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49976 9.49958V17.2496C2.49976 17.9463 2.49976 18.2947 2.54305 18.5866C2.80157 20.3294 4.17001 21.6978 5.91283 21.9563C6.2047 21.9996 6.55305 21.9996 7.24976 21.9996L9.19157 21.9996M0.999756 10.9996L7.47427 4.52506C9.05834 2.94099 9.85037 2.14896 10.7637 1.85221C11.5671 1.59118 12.4325 1.59118 13.2358 1.85221C14.1491 2.14896 14.9412 2.94099 16.5252 4.52506L22.9998 10.9996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.125 17.9708L18.45 18.2417C19.3495 18.9912 19.7992 19.366 19.9492 19.6507C20.3958 20.4979 20.0164 21.5457 19.131 21.9107C18.8335 22.0333 18.2481 22.0333 17.0772 22.0333H16.5C14.8542 22.0333 14.0313 22.0333 13.6413 21.7951C12.9923 21.3987 12.705 20.6053 12.9498 19.8853C13.0969 19.4526 13.7291 18.9258 14.9934 17.8721L18.0066 15.3612C19.2709 14.3076 19.9031 13.7808 20.0502 13.3481C20.295 12.6281 20.0077 11.8347 19.3587 11.4383C18.9687 11.2 18.1458 11.2 16.5 11.2H15.9228C14.7519 11.2 14.1665 11.2 13.869 11.3227C12.9836 11.6877 12.6042 12.7354 13.0508 13.5827C13.2008 13.8674 13.6505 14.2421 14.55 14.9917L14.875 15.2625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
